var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheque(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 51,
    viewBox: "0 0 104 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 51,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1031_5724",
    transform: "matrix(0.0067176 0 0 0.0136986 -0.00381981 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1031_5724",
    width: 150,
    height: 73,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAABJCAIAAABQC0hPAAAD00lEQVR4nO2dz2vTYBjH8+ZNk3T9BfvlD6aCPyYOxSm7bDDmZQfBk148+j94FC/+CZ4ET948eBEEwYMggx1EHcpUrNvcWtaO1nW2XZukSRMPb3gto60JpiaPPp9L892bvn2yz/b0TRMomb11T0AgI4ZdAPKnSOxh4dLpyePj4ZaC+CKbK71aWRO4wsnj4/PTp0ItCfENU4iNFDyoEDyoEDyoEDxS2AVEi4ZmfMh+C2q2iUOjxw6PBjLt6WNHxoYzXYf8KVzeEx7l/6SS4JlQhbuTgc2mG63sZkGRYyy2TMtxHB5Ny2q3bVWRWbSstmm146ob223bMM0hVXGjbcuxGFOoG62Pa/nkkMpfqN7QUok4j/tNPRFXCCEsNpq6qspUdHtkUzdGMulgFP4PXDhz4vKUe361+jVXb2qzF8+ymN0qFMuVhZnzLG4VStnNwuLcNIvF8t7bT+vXFmZY3K3WN7dLfNqYRG9enefx4ZMXnfHR05c3FufkmKvj8fOlxbnpkUyKxWev3vQpGN8LwYMKwYMKwYMKwYMKwYMr0oOUKtXVrzm2XfxeMVomj+W9anW/yWOlVq81fsVao9nQdB4bui5Ryqe1bZsPMTqjbduf1vN8/5ZpreWKRXXPnUrT+xTsT+H5lHD7pK9nDByF/n4f70hUbGpGdnO784d9IhFIZ4xR2hnPnZrg02aSic6hkUyqM2aSiY38Do/JuLq9s9s5LT837VKzh+P6RVoS0klfzwBGJpW4vjgLZVqGq7AmWV+0HwN6DWQQ1CSLbbgK80P6yu5aePUgvhkdclsrrkjBgwrBgwrBgwrB4/WkwrEFx3YGWko4EEGkpNdgdI6aUH4x8SBeFZqGbezbgVUUGUQqJIZ7/hKic9TxNJWU7g6xkYIHFYIHFYIHFYLH63JGpKTX2yloeq7zBEGI0lGT3v9rXhVKMpHkQK/rQADEUWMjBQ8qBA8qBA8qBA8qBA/eweaJiURGFMI8uygbDc0yuw6hQk/cuXAlLvW8h+wvcP/z8rvdQtchbKTgQYXg8dpIrZZjGZG4chYshBAlCfvv2KtCu+2YeiSuXweLSB0FeCuCXT0ioMJ/AFQIHlQIHq/LmZgiUikSFz+RA3hVSESBiqgwimAjBQ8qBA9+zO2JB9nXtO+NUoNmo17pNYQKPfG+Ugy7hJ5gIwUPKgQPKgQPKgSPu5wZM+Sp0bFwS0F8Ud6usg1X4bghz6ePhlcP4pulDY1tYCMFDyoEDyoEDyoEDyoEDyoEDyoEDyoEDyoEDyoEj/sBWzZX6r8fEjW4MoJfig4dbKTg+QlHsymFHRI/6QAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheque);
export default __webpack_public_path__ + "static/media/cheque.3aa85afbfd28e354ea21a3f79bd72bcf.svg";
export { ForwardRef as ReactComponent };